import * as React from 'react';
import { Events } from '@type-r/models';
import { CompaniesLandingPage } from './companies-list';
import { EditCompany } from './edit-company';
import { FormdataService } from "../../services/formdata.service";


// Company management page
export const CompaniesPage = () => {
    const companyId = getCompanyId();
    const companyCountries = getCompanyCountries();

    return (
        !companyId ?
            <CompaniesLandingPage/>
        :
            <EditCompany companyId = { companyId } companyCountries = {companyCountries} />
        )
}

function getCompanyId() {
    const path = window.location.pathname.split('/');
    return path.length === 3 ? path[2] : null;
}

function getCompanyCountries(){
  const service = new FormdataService();
  return service.countries.sort((a, b) => a.name.localeCompare(b.name)) as any;;
}

function back() {
    Events.trigger('navigate', window.location.pathname.split('/').slice(0, 2).join('/'));
}
